import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { observer } from 'mobx-react';
import { measureText, getContainingView, getContainingTrack } from '@jbrowse/core/util';
import { getConf } from '@jbrowse/core/configuration';
import { BaseLinearDisplayComponent } from '@jbrowse/plugin-linear-genome-view';
import YScaleBar from '../../shared/YScaleBar';
var LinearWiggleDisplay = observer(function (props) {
  var model = props.model;
  var stats = model.stats,
    height = model.height,
    needsScalebar = model.needsScalebar;
  var _getContainingView = getContainingView(model),
    trackLabels = _getContainingView.trackLabels;
  var track = getContainingTrack(model);
  var left = trackLabels === 'overlapping' ? measureText(getConf(track, 'name'), 12.8) + 100 : 50;
  return React.createElement("div", null, React.createElement(BaseLinearDisplayComponent, _objectSpread({}, props)), stats && needsScalebar ? React.createElement("svg", {
    style: {
      position: 'absolute',
      top: 0,
      left: left,
      pointerEvents: 'none',
      height: height,
      width: 50
    }
  }, React.createElement(YScaleBar, {
    model: model
  })) : null);
});
export default LinearWiggleDisplay;
export { YScaleBar };